import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router-dom";
import cinstance from "../../Service/randomcinstance";
import usercinstance from "../../Service/usercinstance";
import giftcardcinstance from "../../Service/giftcardcinstance";
import web3 from "../../Service/web3";
import HowToPlay from "../../Components/HowToPlay";
import Roadmap from "../../Components/Roadmap";
import { NavBar, Hero as Banner, PopularGames } from "../../Components/home";
import moment from "moment";
import Whyus from "../../Components/Whyus";
import FundRaise from "../../Components/FundRaise";
import { networkID } from "../../../static/utils";
import PartnersCarousel from "../../Components/partners-carousel/PartnersCarousel";
import GameArenaSection from "../../Components/GameArenaSection/GameArenaSection";
import "./Homepage.css";

const GameSection = ({ id, kicker, title, copy, href, cta, items, renderItem }) => {
  if (!items?.length) return null;

  return (
    <Box component="section" id={id} className="home-section">
      <Container className="home-container" maxWidth={false}>
        <Box className="home-panel">
          <Box className="home-section-head">
            <Box>
              <Typography component="p" className="home-kicker">{kicker}</Typography>
              <Typography component="h2" className="home-section-title">{title}</Typography>
              {copy ? <Typography component="p" className="home-section-copy">{copy}</Typography> : null}
            </Box>
            <Box component="a" href={href} className="home-cta">
              {cta}
              <span aria-hidden="true">→</span>
            </Box>
          </Box>
          <Grid container className="home-grid lottery-section2 text-center">
            {items.slice(0, 3).map(renderItem)}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const Homepage = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [bookiesarray, setBookiesArray] = useState([]);
  const [lotterylist1, setLotterylist1] = useState([]);
  const [lotterylist2, setLotterylist2] = useState([]);
  const [lotterylist3, setLotterylist3] = useState([]);
  const [lotterylist4, setLotterylist4] = useState([]);
  const [giftcardlist, setGiftcardlist] = useState([]);
  const [partnerlist, setPartnerlist] = useState([]);
  const [partnerLogoData, setPartnerLogoData] = useState([]);
  const [giftcardLogoData, setGiftcardLogoData] = useState([]);

  const [buytotal, setBuytotal] = useState(0);
  const [totallotteries, setTotallotteries] = useState(0);
  const [bookies, setBookies] = useState(0);
  const [draws, setDraws] = useState(0);
  const [wins, setWins] = useState(0);
  const [net, setNet] = useState(false);
  const [warn, setWarn] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");

  const checkWallet = async () => {
    try {
      const accounts = await web3.eth.getAccounts();
      setWalletAddress(accounts[0] || "");
    } catch (error) {
      setWalletAddress("");
    }
  };

  const handleConnectWallet = () => {
    if (!window.ethereum) return;
    window.ethereum.enable().then(() => checkWallet()).catch(() => {});
  };

  const getglobaldata = async () => {
    const lotterylist1Data = [];
    const lotterylist2Data = [];
    const lotterylist3Data = [];
    const lotterylist4Data = [];
    const partnerlists1 = [];
    const partnerlists2 = [];
    const partnerlists3 = [];
    const partnerlists4 = [];
    const giftcardlistData = [];
    const partnerlistData = [];
    const bookiesarrayData = [];
    let counts = 0;

    setLoading(true);

    try {
      await Promise.all([
        cinstance.methods.totalSale().call().then((res) => setBuytotal(res)),
        cinstance.methods.totalDraws().call().then((res) => setDraws(res)),
        cinstance.methods.totalWinners().call().then((res) => setWins(res)),
        usercinstance.methods.ownerId().call().then(async (res) => {
          setBookies(res);
          for (let i = res - 1; i > 0; i--) {
            try {
              const responseAddress = await usercinstance.methods.organisationbyid(i).call();
              const response = await usercinstance.methods.organisationbyaddr(responseAddress).call();
              bookiesarrayData.push(response);
              setBookiesArray([...bookiesarrayData]);
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("error", error)),

        cinstance.methods.lotteryId().call().then(async (res) => {
          setTotallotteries(res);
          for (let i = 1; i < res; i++) {
            if (counts === 3) break;
            try {
              const response = await cinstance.methods.lottery(i).call();
              if (response.status === "2") continue;

              if (response.lotteryType == 0) {
                if (response.status === "0" || response.status === "5") {
                  lotterylist1Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists1.push(responsee);
                    setLotterylist1([...lotterylist1Data]);
                  });
                }
              } else if (response.lotteryType == 2) {
                if (response.status === "0" || response.status === "3" || response.status === "5") {
                  lotterylist2Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists2.push(responsee);
                    setLotterylist2([...lotterylist2Data]);
                  });
                }
              } else if (response.lotteryType == 1) {
                if (response.status === "0" || response.status === "5") {
                  if (response?.lotteryId) lotterylist3Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists3.push(responsee);
                    setLotterylist3([...lotterylist3Data]);
                  });
                }
              } else {
                if (response.status === "0" || response.status === "3" || response.status === "5") {
                  lotterylist4Data.push(response);
                  cinstance.methods.partnerbyaddr(response.partnerAddress).call().then((responsee) => {
                    partnerlists4.push(responsee);
                    setLotterylist4([...lotterylist4Data]);
                  });
                }
              }

              lotterylist1Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist2Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist3Data.sort((a, b) => b.lotteryId - a.lotteryId);
              lotterylist4Data.sort((a, b) => b.lotteryId - a.lotteryId);

              setLotterylist1([...lotterylist1Data]);
              setLotterylist2([...lotterylist2Data]);
              setLotterylist3([...lotterylist3Data]);
              setLotterylist4([...lotterylist4Data]);
              counts++;
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("res", error)),

        cinstance.methods.partnerId().call().then(async (res) => {
          for (let i = 0; i <= res; i++) {
            try {
              const responseAdd = await cinstance.methods.partnerids(i).call();
              const response = await cinstance.methods.partnerbyaddr(responseAdd).call();
              if (response.partnerAddress !== "0x0000000000000000000000000000000000000000") {
                partnerlistData.push(response);
                setPartnerlist([...partnerlistData]);
              }
            } catch (error) {
              console.log("error", error);
            }
          }
        }).catch((error) => console.log("res", error)),

        giftcardcinstance.methods.giftCardId().call().then(async (res) => {
          for (let i = 0; i < res; i++) {
            try {
              const response = await giftcardcinstance.methods.giftCards(i).call();
              const currentDT = moment().unix();
              if (response.isSold === false && response.expDate > currentDT) {
                giftcardlistData.push(response);
                setGiftcardlist([...giftcardlistData]);
              }
            } catch (error) {
              console.log("error", error);
            }
          }
          giftcardlistData.sort((a, b) => b.giftCardId - a.giftCardId);
          setGiftcardlist([...giftcardlistData]);
        }).catch((error) => console.log("error", error)),
      ]);

      setLoading(false);

      const scrollToSection = window.location.hash.slice(1);
      if (scrollToSection === "partners") {
        const partnerSection = document.getElementById("partner");
        if (partnerSection) {
          partnerSection.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_KEY;

    if (window.ethereum) {
      getglobaldata();
      web3.eth.net.getId().then((netId) => {
        if (netId == networkID) {
          window.web3 = web3;
          setWarn(false);
        } else {
          setWarn(true);
          setNet(true);
        }
      });

      checkWallet();
      window.ethereum.on("accountsChanged", checkWallet);
    }

    if (apiUrl) {
      axios.get(`${apiUrl}/s3imageupload/getAllPartnerLogos`)
        .then((response) => setPartnerLogoData(response?.data?.result || []))
        .catch(() => setPartnerLogoData([]));

      axios.get(`${apiUrl}/giftcardlogos/getAllGiftcardLogos`)
        .then((response) => setGiftcardLogoData(response?.data?.result || []))
        .catch(() => setGiftcardLogoData([]));
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener("accountsChanged", checkWallet);
      }
    };
  }, []);

  return (
    <Box id="homePage" className="home-modern" sx={{ p: 0, m: 0 }}>
      <NavBar />
      
      <Banner
        variant="home"
        bookies={bookies === 0 ? "0" : Math.abs(bookies - 1)}
        lotteries={totallotteries === 0 ? "0" : Math.abs(totallotteries - 1)}
        buytotal={buytotal}
        draws={draws}
        wins={wins}
      />

      <PopularGames />
      
      <GameArenaSection
        walletAddress={walletAddress}
        onConnect={handleConnectWallet}
        lotterylist1={lotterylist1}
        lotterylist2={lotterylist2}
        lotterylist3={lotterylist3}
        lotterylist4={lotterylist4}
        giftcardlist={giftcardlist}
        partnerlists1={[]}
        partnerlists2={[]}
        partnerlists3={[]}
        partnerlists4={[]}
        partnerLogoData={partnerLogoData}
        giftcardLogoData={giftcardLogoData}
        history={history}
      />

      <Box component="section" className="home-band home-band-play">
        <HowToPlay />
      </Box>

      <Box component="section" className="home-band home-band-why">
        <Whyus />
      </Box>

      <Box component="section" className="home-band home-band-raise">
        <FundRaise />
      </Box>

      <Roadmap />

      <Box component="section" id="partner" className="home-partner">
        <Container className="home-container" maxWidth={false}>
          <Box className="home-panel home-partner-panel">
            <Typography component="p" className="home-kicker">Partnerships</Typography>
            <Typography component="h1" className="home-partner-title">
              <Box component="span" className="red-text-color">AutoBET</Box>{" "}
              invites eligible partners that aim to support charity and web3 development organizations
            </Typography>
            <Typography component="p" className="home-partner-copy">
              Organizations that meet AutoBET set criteria are eligible to join and earn on the platform. 
              Check the Frequently Asked Questions <Box component="a" href="/help">(FAQ)</Box> or email{" "}
              <Box component="a" href="mailto:info@autobetlottery.com">info@autobetlottery.com</Box>{" "}
              for partnership details.
            </Typography>
            <PartnersCarousel data={partnerlist} />
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Homepage;